<template>
  <div>
    <b-card no-body>
      <div class="card-smallHeader card-header-action"
          :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="collapse-pieces-jointes"
          >
        <span><b>Pièces Jointes</b></span>
        <div class="card-header-actions" v-b-toggle.collapse-pieces-jointes>
          <span class="when-opened">
            <i class="icon-arrow-down"></i>
          </span>
          <span class="when-closed">
            <i class="icon-arrow-up"></i>
          </span>
        </div>
      </div>
      <b-collapse id="collapse-pieces-jointes" v-model="visible" class="m-3" :class="visible ? null : 'collapsed'">
        <b-row>
          <b-col class="col-lg-6 col-md-12 pj-bloc">
            <div class="table-wrapper">
              <div class="table-scroll">
                <b-table class="table-pj" striped hover :items="piecesJointesInterne" :fields="fields" primary-key="id">
                  <template #cell(dossier_id)="data">
                    <img style="width: 20px;" class="mr-1" :src="getIconSrc(data.item)"> {{ getPjDossierId(data.item) }}
                  </template>
                  <template #cell(date_reception)="data">
                    {{ shortFormatDate(data.item.date_reception) }}
                  </template>
                  <template #cell(name)="data">
                    <a :id="`pj_${data.item.id}`" href="#" @click.prevent="download(data.item.id,data.item.name)"><span :title="data.item.name"> {{ reducedFileName(data.item.name) }}</span></a>
                    <i v-if="data.item.description" class="fa fa-question-circle ml-2" v-b-tooltip.hover :title="data.item.description"></i>
                    <!-- <i class="fa fa-pencil ml-1 clickable float-right" v-b-tooltip.hover.left title="Modifier le nom de la pièce jointe" @click="initModifyPj(data.item)"></i> -->
                  </template>
                  <template #cell(size)="data">
                    {{ getReadableFileSize(data.item.size) }}
                  </template>
                  <template #cell(categorie)="data">
                    <span :id="`tooltip-cat-${data.item.id}`">{{ getCategorie(data.item).length > 15 ? getCategorie(data.item).substring(0,12) + '...' : getCategorie(data.item) }}</span>
                    <b-tooltip v-if="getCategorie(data.item).length > 15" :target="`tooltip-cat-${data.item.id}`" triggers="hover" placement="left">{{ getCategorie(data.item) }}</b-tooltip>
                  </template>
                  <template #cell(is_visible_for_client)="data">
                    <!-- <i title="Changer la visibilité" v-if="data.item.is_visible_for_client" class="fa fa-check clickable" @click="changeVisibility(data.item.id, data.item.is_visible_for_client)"></i>
                    <i title="Changer la visibilité" v-if="!data.item.is_visible_for_client" class="fa fa-times clickable" @click="changeVisibility(data.item.id, data.item.is_visible_for_client)"></i> -->
                    <i v-if="data.item.is_visible_for_client" class="fa fa-check" ></i>
                    <i v-if="!data.item.is_visible_for_client" class="fa fa-times"></i>
                  </template>
                  <template #cell(action)="data">
                    <b-button type="button"
                      title="télécharger"
                      @click="download(data.item.id,data.item.name)"
                      size="sm"
                      variant="secondary">
                      <i class="fa fa-download"></i>
                    </b-button>
                    <b-button type="button"
                      title="Supprimer"
                      v-if="canDelete(data.item)"
                      @click="deletePj(data.item.id,data.item.name)"
                      size="sm"
                      class="ml-1"
                      variant="danger">
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth';
import { downloadFile, isEmpty, nl2br, getIconSrc as getIconSrcMain, getReadableFileSize as getReadableFileSizeMain, permittedExtension, guardedFile } from "@/utils/fileHelper";
import { isResponsable } from "@/utils/userHelper";

export default {
  name: "ControlePj",
  props: [
    'dossier',
    'controle'
  ],
  data() {
    return {
      visible: false,
      piecesJointes: [],
      fields: [{ key: 'dossier_id', label: 'N° Dossier', class: 'text-nowrap'},
        { key: 'date_reception', label: 'Date' },
        { key: 'name', label: 'Libellé', class: 'text-nowrap'},
        { key: 'size', label: 'Taille', class: 'text-nowrap'},
        { key: 'categorie', label: 'Catégorie', sortByFormatted: true, sortable: true, formatter: (value, key, item) => {
            return this.getCategorie(item);
          }
        },
        { key: 'is_visible_for_client', label: 'Visu Clt', class: 'text-center' },
        { key: 'action', label: '' }],
      sortBy: 'categorie',
      extensionIcon: [],
      newFilename: '',
      pjToRename: {},
      selectedType: null,
      selectedTypeSecondaire: null,
      disableSousType: true,
    }
  },
  watch: {
    dossier() {
      this.piecesJointes = this.dossier.pieces_jointes;
    }
  },
  computed: {
    piecesJointesInterne() {
      return _.filter(this.piecesJointes, (pj) => pj.controle_id === this.controle.id);
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    //this.getTypesPiecesJointes();
  },
  mounted() {
    this.visible = this.piecesJointes.length > 0;
  },
  methods: {
    getCategorie(pj) {
      let textSecondaire = pj.type_secondaire ? (pj.type_secondaire.libelle.length > 30 ? pj.type_secondaire.libelle.substring(0,27)+'...' : pj.type_secondaire.libelle) : '';
      let text = pj.type_principale ? (textSecondaire !== '' ? pj.type_principale.libelle + ' - ' + textSecondaire : pj.type_principale.libelle) : '';
      return text;
    },
    getIconSrc(pj) {
      return pj.extension !== undefined ? getIconSrcMain(pj) : '';
    },
    getPjDossierId(pj) {
      if (pj.dossier_source_id) {
        return pj.dossier_source_id;
      } else {
        if (pj.source === 'gestionnaire') {
          return pj.dossier_id;
        } else {
          return pj.source_id ? pj.source_id : pj.dossier_id;
        }
      }
    },
    shortFormatDate(textDate) {
      let formattedDate = null;
      if(!isEmpty(textDate)) {
        let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
        formattedDate = `${date[0]}/${date[1]}/${date[2].slice(-2)}`;
      }
      return formattedDate;
    },
    download(id, filename) {
      let fileNameArr = filename.trim().split('.');
      let ext = fileNameArr.pop();
      let name = fileNameArr.join('.');
      let link = document.getElementById('pj_'+id);
      link.style.color = 'violet';
      if(this.canDownloadGuardedFile(ext)) {
        this.$axios
          .get("/espaceGestion/dossier-pieces-jointes/download/"+id, {responseType: 'blob'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch(() => {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      } else {
        this.$swal({
          position: "top",
          type: "error",
          title: "Attention !!",
          text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
          showConfirmButton: false,
          timer: 3500
        });
      }
    },
    canDownloadGuardedFile(extension) {
      let valid = true;
      if(_.includes(guardedFile, extension)) {
        valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
      }
      return valid;
    },
    reducedFileName(name) {
      if (name.length > 23) {
        return name.substring(0, 20) + ' ...';
      } else {
        return name;
      }
    },
    initModifyPj(pj) {
      this.clearForm();

      let filenameArr = pj.name.split('.');
      filenameArr.splice(filenameArr.length - 1,1);
      this.newFilename = filenameArr.join('.');
      this.pjToRename = pj;
      this.selectedType = pj.type_principal_id;
      if (!isEmpty(pj.type_principal_id)) { this.typeChanged(); }
      this.selectedTypeSecondaire = pj.type_secondaire_id;

      //this.$refs['modal-modify-pj'].show();
    },
    clearForm() {
      this.selectedType = null;
      this.selectedTypeSecondaire = null;
      this.disableSousType = false;
    },
    canDelete(pj) {
      // console.log('pj',pj)
      let user = getUser();
      return ((isResponsable() && pj.source === 'gestionnaire') || (pj.source === 'gestionnaire' && pj.source_id === user.id)) && pj.can_be_deleted;
    },
    deletePj(pjId) {
      let self = this
      let data = {};
      data.traitementId = this.$route.query.traitementId;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: 'Voulez-vous vraiment supprimer ce fichier ?',
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
      }).then((result) => {
        if (result.value !== true) {
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post("/espaceGestion/dossier-pieces-jointes/delete/"+pjId,data)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$event.emit('refreshDossier');
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le fichier a bien été supprimé',showConfirmButton: false, timer: 3000})
            })
            .catch(function(error){
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
            })
        }
      })
    },
    getReadableFileSize(fileSizeInBytes) {
      return getReadableFileSizeMain(fileSizeInBytes)
    },
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

</style>
